var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEfficientIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60.84041 64.32597",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".d,.e{fill:#fff;}.f{fill:#515151;}.e{stroke:#515151;stroke-miterlimit:10;stroke-width:.75px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "d",
    cx: 31.20918,
    cy: 30.09888,
    r: 27.25986
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M31.30917,59.06249C15.02542,59.06249,1.77792,45.81499,1.77792,29.53124S15.02542,0,31.30917,0s29.53124,13.2475,29.53124,29.53124-13.2475,29.53124-29.53124,29.53124Zm0-55.29254C17.10446,3.76995,5.54787,15.32653,5.54787,29.53124s11.55659,25.7613,25.7613,25.7613,25.7613-11.55659,25.7613-25.7613S45.51388,3.76995,31.30917,3.76995Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "f",
    points: "43.24733 31.41622 29.42419 31.41622 29.42419 12.56649 33.19414 12.56649 33.19414 27.64627 43.24733 27.64627 43.24733 31.41622"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 15.03024,
    cy: 49.29574,
    r: 15.03024
  }), /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 31.30917,
    y1: 3.49865,
    x2: 31.30917,
    y2: 8.53535
  }), /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 31.20918,
    y1: 50.8854,
    x2: 31.20918,
    y2: 55.24396
  }), /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 57.41166,
    y1: 29.04149,
    x2: 53.05309,
    y2: 29.04149
  }), /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 9.36527,
    y1: 29.04149,
    x2: 5.00671,
    y2: 29.04149
  }), /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 44.50985,
    y1: 6.4658,
    x2: 42.2974,
    y2: 10.22108
  }), /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 18.62245,
    y1: 6.06011,
    x2: 20.71615,
    y2: 9.88287
  }), /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 41.70222,
    y1: 48.20011,
    x2: 43.79592,
    y2: 52.02286
  }), /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 9.4654,
    y1: 14.42036,
    x2: 13.0823,
    y2: 16.85246
  }), /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 49.33607,
    y1: 41.23052,
    x2: 52.95297,
    y2: 43.66262
  }), /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 53.64608,
    y1: 15.508,
    x2: 49.91389,
    y2: 17.75919
  }), /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 12.50448,
    y1: 40.32379,
    x2: 8.77229,
    y2: 42.57497
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M14.41749,53.54627H6.93898l2.93359-3.19678c.5127-.57178,1.29004-1.5249,1.59766-1.99414,.21973-.35205,.58691-.98242,.58691-1.65723,0-.36621-.14648-.74756-.38184-.96777-.19043-.17578-.5127-.27832-.89453-.27832-.4248,0-.70312,.14648-.89355,.35205-.26465,.29297-.41113,.8208-.41113,1.20215h-2.25781c.07324-.85059,.41016-1.81836,1.01172-2.44873,.46875-.49854,1.30469-1.01172,2.69824-1.01172,1.42188,0,2.18457,.58643,2.53613,.92383,.52832,.52783,.90918,1.33447,.90918,2.34619,0,.86523-.26367,1.49561-.73242,2.15527-.42578,.58691-.93848,1.08545-1.56934,1.68652l-1.02637,.98242h3.37207v1.90625Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M22.39503,52.75428c-.57129,.55762-1.42188,1.01172-2.62402,1.01172-1.17383,0-2.00879-.43945-2.5957-1.01172-.95312-.93848-1.4082-2.41943-1.4082-4.09082,0-1.68652,.45508-3.18213,1.4082-4.10596,.58691-.57178,1.42188-1.01172,2.5957-1.01172,1.20215,0,2.05273,.45459,2.62402,1.01172,.95312,.92383,1.4082,2.41943,1.4082,4.10596,0,1.67139-.45508,3.15234-1.4082,4.09082Zm-3.51855-6.90625c-.71875,.70361-.82129,2.11133-.82129,2.80078,0,.76221,.13184,2.14062,.82129,2.81543,.26367,.24902,.52734,.36621,.90918,.36621,.38086,0,.64453-.11719,.90918-.36621,.68848-.6748,.82129-2.05322,.82129-2.81543,0-.68945-.10352-2.09717-.82129-2.80078-.26465-.24951-.52832-.3667-.90918-.3667-.38184,0-.64551,.11719-.90918,.3667Z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEfficientIcon);
export default __webpack_public_path__ + "static/media/Efficient-icon.c94438cd7ac435cf371cb76bf01ca8ab.svg";
export { ForwardRef as ReactComponent };